// If size is written as waist/length i.e 32/22 we know its waist length

const EXCLUDE_LIST = [
  'gid://shopify/Product/6925491830867',
  'gid://shopify/Product/6925491798099'
];

export function sizeOptionIsWaistLength(options, product,  _key) {
  const sampleSizeOption = Array.from(options.get(_key).values())[0];
  if (EXCLUDE_LIST.includes(product.productReferenceV2.id)) return false;
  if (sampleSizeOption.value.includes('/') && !isNaN(sampleSizeOption.value.split('/')[0])) return true;
  return false;
}
